var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenZLandingPageWallpaper({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4096,
    height: 2304,
    viewBox: "0 0 1083.7333 609.6",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect7406-7",
    style: {
      fill: "#97D2FB",
      fillOpacity: 0.563433,
      stroke: "#767676",
      strokeWidth: 0,
      strokeLinecap: "round"
    },
    d: "M 1095.3394,45.580679 706.29644,256.55126 749.34911,281.40814 1113.6199,83.87084 Z M 589.63173,319.81665 35.09605,620.5306 53.37715,658.82077 632.6844,344.67302 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect7406-6",
    style: {
      fill: "#97D2FB",
      fillOpacity: 0.563433,
      stroke: "#19a3e3",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeOpacity: 0.564706
    },
    d: "M 962.84865,-117.876 711.25115,18.560625 754.30486,43.4175 981.12975,-79.585325 Z M 594.58642,81.82548 -97.39407,457.0739 l 18.2805,38.29017 716.75369,-388.6817 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect7406-70",
    style: {
      fill: "#97D2FB",
      fillOpacity: 0.563433,
      stroke: "#767676",
      strokeWidth: 0,
      strokeLinecap: "round"
    },
    d: "M 892.14662,-186.05892 138.2882,222.74402 181.34139,247.60091 910.42712,-147.76876 Z M 21.62297,286.0089 l -189.71969,102.88157 18.2811,38.29069 214.49229,-116.31538 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect7406-3",
    style: {
      fill: "#97D2FB",
      fillOpacity: 0.563433,
      stroke: "#767676",
      strokeWidth: 0,
      strokeLinecap: "round"
    },
    d: "M 824.41527,-245.66201 354.71582,9.047 397.769,33.90388 842.69637,-207.37184 Z m -586.36416,317.97439 -473.87863,256.97501 18.2811,38.29069 498.65071,-270.40882 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect7406-99",
    style: {
      fill: "#97D2FB",
      fillOpacity: 0.563433,
      stroke: "#767676",
      strokeWidth: 0,
      strokeLinecap: "round"
    },
    d: "m -494.55952,313.03211 1060.243,-574.9497 18.2808,38.29029 -1060.243,574.9497 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect7406-72",
    style: {
      fill: "#97D2FB",
      fillOpacity: 0.563433,
      stroke: "#767676",
      strokeWidth: 0,
      strokeLinecap: "round"
    },
    d: "M 1348.6526,181.04215 752.98455,504.06172 796.03773,528.91861 1366.9336,219.33287 Z M 636.3204,567.32661 288.40981,755.99209 306.69031,794.28226 679.37354,592.18348 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect7406",
    style: {
      fill: "#97D2FB",
      fillOpacity: 0.563433,
      stroke: "#767676",
      strokeWidth: 0,
      strokeLinecap: "round"
    },
    d: "m 1245.7017,128.21232 -590.75979,320.3577 43.05319,24.8569 565.9877,-306.92444 z m -707.42399,383.6231 -352.81876,191.32683 18.2805,38.29017 377.59091,-204.76063 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect7406-36",
    style: {
      fill: "#97D2FB",
      fillOpacity: 0.563433,
      stroke: "#767676",
      strokeWidth: 0,
      strokeLinecap: "round"
    },
    d: "m 1452.9584,243.35463 -348.6423,189.06187 43.0532,24.85688 323.8696,-175.62806 z m -465.30704,252.32726 -594.93629,322.62267 18.2811,38.29018 619.70833,-336.05597 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenZLandingPageWallpaper);
export default __webpack_public_path__ + "static/media/GenZLandingPageWallpaper.03e85d3a49bb552180cef050dd408968.svg";
export { ForwardRef as ReactComponent };